var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 232,
    height: 58,
    viewBox: "0 0 232 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1444_19480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6.84698H4.72955V51.153H0V6.84698ZM7.62423 51.153H10.2869V6.84698H7.62423V51.153ZM12.2061 51.153H14.8636V6.84698H12.2061V51.153ZM18.3593 51.153H24.1803V6.84698H18.3593V51.153ZM28.8413 51.153H31.7518V6.84698H28.8413V51.153ZM36.2652 51.153H48.329V6.84698H36.2652V51.153ZM67.7006 51.153H71.6656V6.84698H67.7006V51.153ZM75.1245 6.84698V51.153H80.5289V6.84698H75.1245ZM53.1692 51.153H55.7634V6.84698H53.1692V51.153ZM59.4806 51.153H62.0747V6.84698H59.4806V51.153Z",
    fill: "#030104"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1444_19480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85 6.84698H89.7296V51.153H85V6.84698ZM92.6242 51.153H95.2869V6.84698H92.6242V51.153ZM97.2061 51.153H99.8636V6.84698H97.2061V51.153ZM103.359 51.153H109.18V6.84698H103.359V51.153ZM113.841 51.153H116.752V6.84698H113.841V51.153ZM121.265 51.153H133.329V6.84698H121.265V51.153ZM152.701 51.153H156.666V6.84698H152.701V51.153ZM160.124 6.84698V51.153H165.529V6.84698H160.124ZM138.169 51.153H140.763V6.84698H138.169V51.153ZM144.481 51.153H147.075V6.84698H144.481V51.153Z",
    fill: "#030104"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1444_19480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151 6.84698H155.73V51.153H151V6.84698ZM158.624 51.153H161.287V6.84698H158.624V51.153ZM163.206 51.153H165.864V6.84698H163.206V51.153ZM169.359 51.153H175.18V6.84698H169.359V51.153ZM179.841 51.153H182.752V6.84698H179.841V51.153ZM187.265 51.153H199.329V6.84698H187.265V51.153ZM218.701 51.153H222.666V6.84698H218.701V51.153ZM226.124 6.84698V51.153H231.529V6.84698H226.124ZM204.169 51.153H206.763V6.84698H204.169V51.153ZM210.481 51.153H213.075V6.84698H210.481V51.153Z",
    fill: "#030104"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1444_19480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.5289,
    height: 58,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1444_19480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.5289,
    height: 58,
    fill: "white",
    transform: "translate(85)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1444_19480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.5289,
    height: 58,
    fill: "white",
    transform: "translate(151)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarCode);
export default __webpack_public_path__ + "static/media/bar-code.b3c3f99550fe4cae742fb178e9bd45a6.svg";
export { ForwardRef as ReactComponent };